// src/Components/Common/Model/Sharepop.js

import toast from "react-hot-toast";
import { Link } from "react-router-dom";

function Sharepop({ open, onClose, title, image }) {
   const handleCopy = () => {
    navigator.clipboard.writeText(window.location.href);
    toast.success("Link copied to clipboard!");
  };
  if (!open) return null;

  return (
    <div className="share-popup">
      <h4>Share this experience</h4>
      <a  className="cross" onClick={onClose}>
        <i className="fa fa-times"></i>
      </a>

      <div className="stl_boths">
        <div className="mgs_bx">
          <img src={image || "/images/what_experience_sm5.png"} alt="" />
        </div>
        <div className="cnt_txttx">{title}</div>
      </div>

      <div className="miaa_linkss">
        <ul>
          <li>
            <Link onClick={(e) => { e.preventDefault(); handleCopy(); }}>
              <img src="/images/share_ic1.png" alt="" /> Copy Link
            </Link>
          </li>
          <li>
            <a href={`mailto:?subject=${title}&body=${window.location.href}`} target="_blank" rel="noreferrer">
              <img src="/images/share_ic2.png" alt="" /> Email
            </a>
          </li>
          <li>
            <a href={`sms:?body=${window.location.href}`} target="_blank" rel="noreferrer">
              <img src="/images/share_ic3.png" alt="" /> Messages
            </a>
          </li>
          <li>
            <a href={`https://wa.me/?text=${encodeURIComponent(`Check this out: ${window.location.href}`)}`} target="_blank" rel="noreferrer">
              <img src="/images/share_ic4.png" alt="" /> Whatsapp
            </a>
          </li>
          <li>
            <a href="https://facebook.com/sharer/sharer.php?u=${window.location.href}" target="_blank" rel="noreferrer">
              <img src="/images/share_ic6.png" alt="" /> Facebook
            </a>
          </li>
          <li>
            <a href={`https://twitter.com/intent/tweet?url=${window.location.href}`} target="_blank" rel="noreferrer">
              <img src="/images/share_ic7.png" alt="" /> Twitter
            </a>
          </li>
          {/* <li>
            <a href="#">
              <img src="/images/share_ic8.png" alt="" /> More Options
            </a>
          </li> */}
        </ul>
      </div>
    </div>
  );
}

export default Sharepop;
